// extracted by mini-css-extract-plugin
module.exports = {"item":"QuoteRowItem_item__12rJv"};